import ButtonGroup, { ButtonGroupProps } from '../ButtonGroup'

export type PaginationProps = ButtonGroupProps
const Pagination = ButtonGroup
export default Pagination
